/* eslint-disable */
const BASE_URL = process.env.REACT_APP_BASE_URL || '';
const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URL || '';
const AZURE_APP_ID = process.env.REACT_APP_AZURE_ID || '';
const AD_GROUP_PREFIX = process.env.REACT_APP_AD_GROUP_PREFIX || '';
const REACT_APP_TRACKER_URL = process.env.REACT_APP_TRACKER_URL || '';
const REACT_APP_TRACKER_API_KEY = process.env.REACT_APP_TRACKER_API_KEY || '';
export { AD_GROUP_PREFIX, AZURE_APP_ID, BASE_URL, REDIRECT_URI, REACT_APP_TRACKER_URL,REACT_APP_TRACKER_API_KEY };
